import { Box, transitionsDelay, Image, Block } from '../../../styles/basicStyles';
import { breakpoints } from '../../../styles/breakpoints';
import styled from 'styled-components';

export const BannerWrapper = styled(Box)<{ backgroundColor: string }>`
  background: ${({ backgroundColor }) => (backgroundColor.md ? backgroundColor.md : 'transparent')};

  @media ${breakpoints.md} {
    background: ${({ backgroundColor }) => (backgroundColor.xxs ? backgroundColor.xxs : 'transparent')};
  }
`;

export const BackgroundContainer = styled(Box)<{background?: string}>`
  background: ${({ background }) => (background ? background : 'transparent')};
`;

export const BannerLink = styled.a`
  cursor: pointer;
  padding: 0 0.375rem;
  flex-shrink: 0;
  margin-bottom: 0.625rem;
`;

export const WebsiteLabel = styled(Box)`
  height: 2.125rem;
  background-color: ${({ theme }) => theme.colors.balticSea};
  padding: 0rem 1rem;
  border-radius: 0.375rem;
  transition: background-color ${transitionsDelay} linear;
  align-items: center;

  &:hover{
    background-color: ${({ theme }) => theme.colors.purple};
  }
`;

export const BannerImgBg = styled(Box)<{url?: string, backgroundColor?: string}>`
  background-position: right;
  background-repeat: no-repeat;
  background-image: url(${({ url }) => url});
  background-size: contain;
  align-items: flex-start;
  z-index: 1;
  
  @media ${breakpoints.xl} {
    background-position: 37.5rem;
  }

  @media ${breakpoints.lg} {
    background-position: 31.25rem;
  }

  @media ${breakpoints.md} {
    background-image: none;
  }
`;

export const BannerImgMobile = styled(Image)`
  max-width: 100%;
  max-height: 18.125rem;
  margin-top: 0.625rem;
`;

export const BarContainer = styled(Box)<{ background: string }>`
  width: 100%;
  z-index: 999;
  position: fixed;
  top: 5rem;
  padding-top: 0.1rem;
  padding-bottom: 0.2rem;
  left: 0;
  transition: opacity ${transitionsDelay} linear;
  background: ${({ background }) => background};
`;

export const DescriptionContainer = styled(Box)`
  border: ${({ theme }) => `0.0625rem solid ${theme.colors.dawnPink}`};
  box-shadow: rgba(189, 189, 189, 0.25) 0rem 0.1875rem 0.375rem;
`;

export const BlockContainer = styled(Block)`
  width: 100%;
  max-width: 83.625rem;
  padding: 0 1.25rem;
  margin: auto;
  display: flex;
`;

export const BlockWrapper = styled(Block)`
  display: flex;
  width: 100%;
  position: relative;

  & .react-reveal {
    width: 100%;
  }
`;

export const TitleWrapper = styled(Block)<{barColor?: string}>`
  position: relative;
  display: inline-block;
  width: auto;

  &:before{
    content: '';
    position: absolute;
    top: -0.938rem;
    height: 0.188rem;
    background-color: ${({ theme, barColor }) => barColor ? barColor : theme.colors.purple}; 
    width: 100%;
  }
`;

export const VideoContainer = styled(Box)<{maxWidth: number}>`
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth > 0 ? `${maxWidth}rem` : "50rem")};
`;

export const NumbersContainer = styled(Box)`
	display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  padding: 3.125rem 0rem;

  @media ${breakpoints.md} {
    justify-content: center;
  }
`;

export const NumberContainer = styled(Box)`
	flex-basis: 33.333%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1.875rem;
  padding: 0rem 0.625rem;

  @media ${breakpoints.xs} {
    padding: 0rem 0.5rem;
    flex-basis: 50%;
  }

  @media ${breakpoints.xxs} {
    padding: 0rem 0.3125rem;
  }
`;

export const NumbersContent = styled(Box)`
  flex-basis: 70%;
  
  @media ${breakpoints.md} {
    flex-basis: 100%;
  }
`;

export const NumbersRow = styled(Box)`
  margin: 0px -0.3125rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const TechStackContainer = styled(Box)`
  width: 100%;
  margin-bottom: 5rem;
`;

export const TechStackContent = styled.div<{top?: boolean}>`
  flex-basis: ${({ top }) => top ? '100%' : '70%'};

  @media ${BarContainer.md} {
    flex-basis: 100%;
  }
`;

export const TechsContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
  margin-left: -1.5625rem;

  @media ${breakpoints.xl} {
    margin-left: -1.25rem;
  }

  @media ${breakpoints.lg} {
    margin-left: -0.9375rem;
  }

  @media ${breakpoints.md} {
    margin-left: -0.3125rem;
  }
`;
